import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap";
import * as fromRootStore from "../../../reducers";
import { ReportService } from "../../../services/index";
declare var google;

@Component({
  selector: "design-wise-so-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./SalesOrderdetails.html",
})
export class SalesOrderDetailsReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() brandUpdateEvent = new EventEmitter();
  @Input() set mapdata(val: any) {
    let id = val;
    this.filterData.so_id = id;
    this.getSalesOrderDetails();
  }

  seasonList = [];
  dataList = [];
  gridOptions: any;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter = {
    fin_id: 3,
    season: 0,
    season_id: 3,
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "agent_name",
    orderDir: "asc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any = {
    fin_id: 3,
    season_id: 6,
    party_id: "",
    so_id: "",
  };
  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private reportService: ReportService,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService
  ) {}

  printConfig: any = {
    title: "Design Wise Sales Order report",
    columns: [],
    rows: [],
  };

  ngOnInit(): void {
    this.columns = [
      {
        name: "Design No",
        prop: "design_no",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Category",
        prop: "category",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "F34",
        prop: "f34",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "F36",
        prop: "f36",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "F38",
        prop: "f38",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "F40",
        prop: "f40",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "F42",
        prop: "f42",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "F44",
        prop: "f44",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "Ftot",
        prop: "ftot",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "H34",
        prop: "h34",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "H36",
        prop: "h36",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "H38",
        prop: "h38",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "H40",
        prop: "h40",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "H42",
        prop: "h42",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "H44",
        prop: "h44",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "Htot",
        prop: "htot",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
      {
        name: "Tot Pcs",
        prop: "tot",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
        summary: "sum",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      maxHeight: window.innerHeight - 300 + "px",
      loading: true,
      data: [],
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    const colName = this.reportName == "design_no" ? "design_no" : "dispName";
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#jdkf").focus();
    }, 100);
  }

  getSalesOrderDetails(): void {
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
      data: [],
    };

    let params = {
      so_id: this.filterData.so_id,
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getSalesOrderDetails(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.dataList = res.data;

        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
      });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/OrderwiseReport/SalesOrderdetails.ts